module.exports = __webpack_public_path__ + "static/media/negative-icon.4f9e4db3.svg";